import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { initialState } from './Contexto/initialState'
import { StateProvider } from './Contexto/store'
import { mainReducer } from './Contexto/Reducers'
import theme from './theme/theme';

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./Configuracion/AuthConfig";
import { ThemeProvider as MuithemeProvider } from '@mui/material/styles';
import { ToastProvider } from 'react-toast-notifications';

import { GnlNotificacionesSistema, GnlNombreCarpetaModulo, GnlCarpetaModulos  } from './Configuracion/Llaves/RepositorioConfig';

import { ClearBrowserCacheBoundary } from 'react-clear-browser-cache';

const msalInstance = new PublicClientApplication(msalConfig);

ReactDOM.render(
    <React.StrictMode>
        <ClearBrowserCacheBoundary auto fallback='Loading' filename={GnlCarpetaModulos.substring(1, GnlCarpetaModulos.length) + '/' + GnlNombreCarpetaModulo + '/meta.json'} duration={60000}>
            <ToastProvider
                placement={GnlNotificacionesSistema.Ubicacion}
                autoDismiss={true}
                autoDismissTimeout={GnlNotificacionesSistema.DuracionMensajes}
                newestOnTop={GnlNotificacionesSistema.MensajesNuevosAlInicio}
            >
                <StateProvider initialState={initialState} reducer={mainReducer}>
                    <MsalProvider instance={msalInstance}>
                        <MuithemeProvider theme={theme}>
                            <App />
                        </MuithemeProvider>
                    </MsalProvider>
                </StateProvider>
            </ToastProvider>
        </ClearBrowserCacheBoundary>
    </React.StrictMode>,
    document.getElementById('root')
);